// extracted by mini-css-extract-plugin
module.exports = {"light":"#EAE9E8","yGrid":"YGrid_yGrid__1oMW_"};